/** The product editor's data in the vendor panel (the store's view of the catalogue), plus query keys. */

import {
  storeCategoriesTree,
  vendorBrandsList,
  vendorCategoriesFormSchemaRetrieve,
  vendorTaxClassesList,
  type ApprovalStatusEnum,
  type TreeNode,
} from "@motolynk/api-client";

import type { CategoryNode, EditorSource } from "../editor/values";

export const vendorProductKeys = {
  all: ["vendor", "products"] as const,
  list: (params: object) => ["vendor", "products", "list", params] as const,
  counts: () => ["vendor", "products", "counts"] as const,
  settings: () => ["vendor", "products", "settings"] as const,
  detail: (uid: string) => ["vendor", "products", "detail", uid] as const,
  history: (uid: string) => ["vendor", "products", "history", uid] as const,
};

/** The store's tabs: everything first, then the approval states. */
export const VENDOR_TABS = [
  "all",
  "draft",
  "pending_review",
  "changes_requested",
  "approved",
  "rejected",
] as const satisfies readonly (ApprovalStatusEnum | "all")[];
export type VendorTab = (typeof VENDOR_TABS)[number];

function toNodes(nodes: TreeNode[]): CategoryNode[] {
  return nodes.map((node) => ({
    uid: node.uid,
    name: node.name,
    children: toNodes((node.children ?? []) as unknown as TreeNode[]),
  }));
}

export const vendorSource: EditorSource = {
  key: "vendor",
  // the public category tree: active categories only, exactly what customers browse
  categories: async () => toNodes((await storeCategoriesTree()).data),
  brands: async () =>
    (await vendorBrandsList()).data.map((brand) => ({ uid: brand.uid, name: brand.name })),
  taxClasses: async () =>
    (await vendorTaxClassesList()).data.map((tax) => ({ uid: tax.uid, name: tax.name })),
  formSchema: async (category) => (await vendorCategoriesFormSchemaRetrieve(category)).data,
};
